/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function TassatLogoAndName(props: CustomSvgIcon) {
    const {
        id,
        className,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
            viewBox='0 0 292.99 70.94'
        >
            <svg
                viewBox='0 0 292.99 70.94'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g
                    data-name='Layer 2'
                    id='Layer_2'
                >
                    <g
                        data-name='Layer 1'
                        id='Layer_1-2'
                    >
                        <path
                            d='M98.78,70.94V15.23H78.17V7.82h49.58v7.41H107.06V70.94Z'
                            fill='#00427a'
                        />
                        <path
                            d='M142.49,69.9a38.3,38.3,0,0,1-.86-6.81c-2.16,5.09-7,7.85-13.89,7.85-9,0-14.48-5.35-14.48-13C113.26,49,120.67,43,133.69,43h7.51V37.74c0-4.66-2.85-7.07-8.54-7.07-5.35,0-8.62,2.76-8.8,7.41h-7.67v-.69c0-7.58,5.61-11.81,15.95-11.81,12.33,0,17.08,4.31,17.08,13.45V65.76a30.56,30.56,0,0,0,.43,4.14Zm-8-21.47c-8.71,0-13,3.54-13,8.71,0,4.14,3.36,7.33,8.19,7.33,7.42,0,11.56-4,11.56-11.73V48.43Z'
                            fill='#00427a'
                        />
                        <path
                            d='M162,56.88v.17c0,4.75,3.62,7.85,9.14,7.85s9.05-2.84,9.05-6.81c0-3-1.64-4.83-5.17-5.69l-9.23-2.16c-7.67-1.81-11.46-5.52-11.46-11.29,0-7.59,6.63-13.28,17.5-13.28,9.83,0,15.69,4.4,15.69,11.38a7,7,0,0,1-.08,1.29H179.5V38c0-4.23-3.19-6.73-8.27-6.73s-8.63,2.85-8.63,6.3c0,2.84,1.9,4.39,6.38,5.6l9.83,2.67c6.73,1.82,10,5.52,10,11.65,0,8-6.47,13.45-17.34,13.45-12,0-17.5-4-17.5-13v-1Z'
                            fill='#00427a'
                        />
                        <path
                            d='M200,56.88v.17c0,4.75,3.62,7.85,9.14,7.85s9.06-2.84,9.06-6.81c0-3-1.64-4.83-5.18-5.69l-9.22-2.16c-7.68-1.81-11.47-5.52-11.47-11.29,0-7.59,6.64-13.28,17.5-13.28,9.83,0,15.69,4.4,15.69,11.38a7,7,0,0,1-.08,1.29h-7.93V38c0-4.23-3.19-6.73-8.28-6.73s-8.62,2.85-8.62,6.3c0,2.84,1.89,4.39,6.38,5.6l9.83,2.67c6.72,1.82,10,5.52,10,11.65,0,8-6.47,13.45-17.33,13.45-12,0-17.51-4-17.51-13v-1Z'
                            fill='#00427a'
                        />
                        <path
                            d='M259.26,69.9a38.07,38.07,0,0,1-.87-6.81c-2.15,5.09-7,7.85-13.88,7.85-9,0-14.48-5.35-14.48-13C230,49,237.44,43,250.46,43H258V37.74c0-4.66-2.84-7.07-8.53-7.07-5.35,0-8.63,2.76-8.8,7.41H233v-.69c0-7.58,5.6-11.81,15.95-11.81C261.24,25.58,266,29.89,266,39V65.76a32.46,32.46,0,0,0,.43,4.14Zm-8-21.47c-8.71,0-13,3.54-13,8.71,0,4.14,3.36,7.33,8.19,7.33,7.41,0,11.55-4,11.55-11.73V48.43Z'
                            fill='#00427a'
                        />
                        <path
                            d='M275.4,26.62V17.74l7.94-2.68V26.62H293v5.69h-9.65V58.86c0,4.32.94,5.52,5.51,5.52a15.43,15.43,0,0,0,4-.6v6a25.46,25.46,0,0,1-6.29,1c-7.76,0-11.13-2.24-11.13-9.14V32.31h-7.33V26.62Z'
                            fill='#00427a'
                        />
                        <path
                            d='M50.78,70.94h0c4.74-2.25,4.23-10.26-1.13-17.89L25.22,18.26C20.49,20.5,21,28.51,26.35,36.15Z'
                            fill='#00427a'
                        />
                        <path
                            d='M31.2,70.94h0C26.47,68.69,27,60.68,32.34,53.05L56.77,18.26C61.5,20.5,61,28.51,55.63,36.15Z'
                            fill='#0066b2'
                        />
                        <path
                            d='M44.33.8h0a7.64,7.64,0,0,0-9.8,2.7L25.19,18.25A7.65,7.65,0,0,0,35,15.56Z'
                            fill='#0066b2'
                        />
                        <path
                            d='M37.64.8h0a7.63,7.63,0,0,1,9.79,2.7l9.35,14.75A7.65,7.65,0,0,1,47,15.56Z'
                            fill='#00427a'
                        />
                        <path
                            d='M8.33,70.58a9.94,9.94,0,0,0,2.63.36H31.19c0-5.06-3.71-8-8.19-8H3.26Z'
                            fill='#00427a'
                        />
                        <path
                            d='M16.69,30.57,2.08,51.34A10.34,10.34,0,0,0,0,57.93l3.26,5L17.93,42.16C21.14,37.61,20.58,32.42,16.69,30.57Z'
                            fill='#0066b2'
                        />
                        <path
                            d='M73.63,70.58a10,10,0,0,1-2.63.36H50.77c0-5.06,3.7-8,8.19-8H78.7Z'
                            fill='#0066b2'
                        />
                        <path
                            d='M65.27,30.57,79.88,51.34a10.34,10.34,0,0,1,2.06,6.59l-3.26,5L64,42.16C60.82,37.61,61.38,32.42,65.27,30.57Z'
                            fill='#00427a'
                        />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}